import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography } from '../../../../styles/typography';
import createButtonCss from '../../../ui/Button/Button';

export const container = css({
  position: 'fixed',
  zIndex: 1,
  bottom: 0,
  width: '100%',
  boxShadow: '0 10px 80px rgba(0, 0, 0, 0.08)',
  backgroundColor: colorsPalette.white,
  paddingTop: 24,
  paddingBottom: 24,
  [MediaQueries.mdAndUp]: {
    paddingTop: 40,
    paddingBottom: 40,
  },
});

export const stepsContainer = css({
  display: 'none',
  [MediaQueries.mdAndUp]: {
    display: 'block',
  },
});

export const stepsLabel = css(typography.effra14, {
  color: colorsPalette.teal,
  marginTop: 4,
  marginBottom: 8,
});

export const stepsProgressBar = css({
  height: 4,
  width: '100%',
  borderRadius: 18,
  backgroundColor: colorsPalette.grey10,
  position: 'relative',
  overflow: 'hidden',
  [MediaQueries.mdAndUp]: {
    maxWidth: 186,
  },
});

export const stepsProgressBarFill = css({
  position: 'absolute',
  height: 4,
  width: '100%',
  borderRadius: 18,
  backgroundColor: colorsPalette.teal,
  transition: `width 0.3s`,
});

export const secondaryCTAContainer = css({
  [MediaQueries.mdAndUp]: {
    textAlign: 'right',
  },
});

export const secondaryCTA = css(typography.effra16, {
  backgroundColor: colorsPalette.transparent,
  border: 0,
  color: colorsPalette.grey60,
  cursor: 'pointer',
  height: 55,
  padding: 0,
  width: '100%',
  [MediaQueries.mdAndUp]: {
    paddingLeft: 16,
    paddingRight: 16,
    textAlign: 'right',
    width: 'auto',
  },
});

export const secondaryCTAIcon = css({
  marginRight: 9,
});

export const submit = css(createButtonCss(), {
  transition: 'background-color 0.3s',
});
